export const smartFarmSolutionHero = {
  eyebrow: '智慧农场解决方案',
  title: '从「种得出来」',
  subtitle: '到「管得精 · 卖得好 · 可持续」',
  desc: '以农业生产为基础、数字技术为支撑、市场需求为牵引，构建「农田感知、智能管理、品质追溯、产品上行、供应链协同、数据运营」的一体化体系。',
  note: '面向农场、合作社、农业产业园与县域农业产业主体，提供从生产到流通的全链路数字化能力。',
  tags: ['农田物联感知', 'TOMA 智能体', 'ePin 数字身份', '数字货架', '供应链协同'],
};

export const industryNeeds = [
  {
    id: 'need-1',
    icon: 'ri-focus-3-line',
    title: '生产管理需要更加精准',
    desc: '传统农业依赖人工经验，土壤、气象、水肥、病虫害和设备状态等信息分散，难以及时发现异常。农场需要通过物联网和数据分析掌握生产状态，提高农事管理的及时性和准确性。',
  },
  {
    id: 'need-2',
    icon: 'ri-shield-check-line',
    title: '农产品品质需要可信表达',
    desc: '消费者越来越关注产品产地、种植过程、检测结果和流通信息。农业经营主体需要建立完整的生产和质量记录，让产品来源可查、过程可追、品质可验证。',
  },
  {
    id: 'need-3',
    icon: 'ri-links-line',
    title: '农业生产需要连接市场需求',
    desc: '传统模式往往是先生产、后寻找渠道，容易出现产销错配、库存积压和供需波动。农场需要打通订单、渠道和消费数据，逐步实现以需定产、以销定供。',
  },
  {
    id: 'need-4',
    icon: 'ri-truck-line',
    title: '农产品流通需要降本增效',
    desc: '农产品在分拣、包装、仓储和运输过程中，存在信息断层、重复装卸和损耗管理困难等问题。农业经营主体需要统一管理产品批次、物流节点和订单履约过程。',
  },
  {
    id: 'need-5',
    icon: 'ri-team-line',
    title: '多方协同需要统一数字基础',
    desc: '农户、合作社、农场、采购商、物流方和消费者之间，需要共享可信的产品、订单、服务和结算信息，形成更加透明、高效的产业协作机制。',
  },
  {
    id: 'need-6',
    icon: 'ri-line-chart-line',
    title: '农业数据需要转化为经营能力',
    desc: '生产、品质、销售、库存和客户数据如果无法沉淀，就难以支持经营决策。农场需要通过数据看板和 AI 工具，提升计划安排、风险预警和市场运营能力。',
  },
];

export const overviewItems = [
  {
    id: 'ov-1',
    icon: 'ri-map-2-line',
    title: '农田数字化',
    desc: '对基地、地块、作物、设施和人员进行数字化建档，接入土壤、气象、水肥、温湿度和设备运行等数据，形成农场数字底图。',
    note: '管理人员可以通过电脑或移动端查看农情状态、设备状态和农事任务，及时发现异常并进行处理。',
  },
  {
    id: 'ov-2',
    icon: 'ri-robot-line',
    title: '农事智能化',
    desc: '通过 TOMA 智能体连接农情数据、农事台账和种植规范，为农场提供智能问答、任务提醒、异常提示和生产辅助。',
    note: '系统帮助农业人员沉淀种植经验和作业标准，提升农事管理的规范性与连续性。',
  },
  {
    id: 'ov-3',
    icon: 'ri-clipboard-line',
    title: '品质标准化',
    desc: '围绕播种、施肥、用药、采收、检测、加工和包装等关键环节建立标准记录，形成从生产到成品的质量管理流程。',
    note: '通过数字化台账，提升产品批次管理、品质控制和质量问题追溯能力。',
  },
  {
    id: 'ov-4',
    icon: 'ri-qr-code-line',
    title: '产品身份化',
    desc: '依托 ePin 数字身份，为产品、批次和包装建立「一品一标、一物一码」的数字档案。',
    note: '消费者可以扫码查看产品产地、生产过程、检测信息和流通记录，农业经营主体也可以利用可信数据进行品牌展示和渠道管理。',
  },
  {
    id: 'ov-5',
    icon: 'ri-store-2-line',
    title: '产品销售数字化',
    desc: '通过数字货架将农产品转化为标准化数字商品，支持产品展示、品牌传播、订单承接、库存管理和渠道协同。',
    note: '数字货架可以连接农场、合作社、门店、企业采购、社区消费及线上渠道，帮助优质农产品实现更高效的市场触达。',
  },
  {
    id: 'ov-6',
    icon: 'ri-exchange-line',
    title: '供应链协同化',
    desc: '连接产地分拣、标准包装、仓储管理、物流配送和售后服务等流程，统一管理产品批次、订单状态和履约进度。',
    note: '通过产品流、订单流和信息流协同，提升多农户、多基地、多品类场景下的供应链管理能力。',
  },
  {
    id: 'ov-7',
    icon: 'ri-dashboard-line',
    title: '经营数据化',
    desc: '沉淀生产、品质、订单、库存、渠道和用户数据，形成农场经营看板。',
    note: '管理者可以根据数据分析产品表现、渠道贡献、库存变化和市场需求，为种植计划、产品结构和销售策略提供参考。',
  },
];

export const overviewLoop = {
  title: '形成持续运营闭环',
  desc: '智慧农场的完整运行路径',
  note: '通过数据持续回流，让农业经营从「经验管理」逐步转向「数据辅助决策」。',
  flow: ['农田感知', '农事管理', '品质检测', '产品追溯', '数字上架', '订单履约', '消费反馈', '生产优化'],
};

export const customerValues = [
  {
    id: 'value-1',
    icon: 'ri-plant-line',
    title: '对农业基地和家庭农场',
    points: [
      '实时掌握基地生产状态，减少管理盲区。',
      '规范农事记录和生产流程，提高管理效率。',
      '建立产品档案和质量追溯能力。',
      '通过数字货架拓展销售渠道和消费场景。',
      '以生产和销售数据辅助安排种植计划。',
    ],
  },
  {
    id: 'value-2',
    icon: 'ri-group-line',
    title: '对农业合作社',
    points: [
      '统一管理多农户、多地块和多品类产品。',
      '建立统一的生产标准和品质标准。',
      '提升产品组织、分拣、包装和交付能力。',
      '形成透明的订单、库存和成员协同机制。',
      '增强合作社的品牌运营和市场议价能力。',
    ],
  },
  {
    id: 'value-3',
    icon: 'ri-building-2-line',
    title: '对农业产业园',
    points: [
      '实现园区生产、设施、产品和人员的统一管理。',
      '建立园区级品质追溯和供应链协同体系。',
      '支持园区品牌、招商和产品展示。',
      '沉淀园区经营数据，为产业规划提供依据。',
      '推动生产、加工、流通、文旅等业态协同发展。',
    ],
  },
  {
    id: 'value-4',
    icon: 'ri-map-pin-line',
    title: '对县域农业产业',
    points: [
      '推动特色农产品标准化、品牌化和数字化。',
      '帮助农产品更高效进入城市消费市场。',
      '促进产业链、供应链和服务链留在县域。',
      '为村集体、农户和产业运营主体提供协同基础。',
      '形成可复制、可推广的县域农业数字化样板。',
    ],
  },
  {
    id: 'value-5',
    icon: 'ri-user-heart-line',
    title: '对消费者',
    points: [
      '通过扫码了解产品来源和生产过程。',
      '获取更加清晰、可信的品质信息。',
      '享受更加透明的农产品消费体验。',
      '增强对产地、品牌和农业生产者的信任。',
    ],
  },
  {
    id: 'value-6',
    icon: 'ri-government-line',
    title: '对农业管理部门',
    points: [
      '掌握区域农业生产、产品和流通情况。',
      '提升农产品质量安全管理的数字化水平。',
      '为产业规划、品牌建设和农业项目管理提供数据支持。',
      '推动数字乡村、县域商业和农业现代化建设协同发展。',
    ],
  },
];

export const solutionSummary = {
  eyebrow: '方案总结',
  title: '连接农田、产品、供应链与市场',
  desc: '智慧农场不是单纯建设一套监测系统，而是将农田、产品、供应链、消费市场和经营数据连接起来，帮助农业经营主体实现：',
  highlights: [
    { icon: 'ri-database-2-line', label: '生产有数据' },
    { icon: 'ri-file-list-3-line', label: '品质有记录' },
    { icon: 'ri-qr-code-line', label: '产品有身份' },
    { icon: 'ri-exchange-line', label: '流通有协同' },
    { icon: 'ri-store-line', label: '销售有渠道' },
    { icon: 'ri-line-chart-line', label: '经营有依据' },
  ],
  closing:
    '华辉数智以人工智能、物联网、ePin 数字身份、数字货架和供应链协同能力，助力农业从「种得出来」走向「管得精、卖得好、可持续」。',
};

export const solutionConsultation = {
  title: '让智慧农场，从规划到落地',
  desc: '无论是标准农田、设施农业，还是农业合作社与县域产业带，我们都可根据您的实际经营场景，提供定制化的智慧农场建设方案。',
  primaryLabel: '获取解决方案',
  secondaryLabel: '体验项目演示',
  formTitle: '获取智慧农场解决方案',
  success: '提交成功，我们将在 1-2 个工作日内与您联系。',
};